<template>
	<div class="mainBox" style="padding-bottom: 0.1rem;">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="编辑巡视记录" left-text="返回" left-arrow
				@click-left="goBack">
			</van-nav-bar>
		</div>
		<van-form @submit="onSubmit">
			<van-cell-group>
				<van-field readonly clickable :value="subjectMatter" name="subjectMatter" label="标的物" placeholder="请选择标的物"
					:rules="[{ required: true, message: '' }]" @click="showSubjectMatterPicker = true" />
				<van-popup v-model="showSubjectMatterPicker" position="bottom">
					<van-picker show-toolbar :columns="subjectMatterList" value-key="displayName"
						@confirm="selSubjectMatter" @cancel="showSubjectMatterPicker = false" />
				</van-popup>
				<van-field readonly clickable :value="major" name="major" label="专业" placeholder="请选择专业"
					:rules="[{ required: true, message: '' }]" @click="showMajorPicker = true" />
				<van-popup v-model="showMajorPicker" position="bottom">
					<van-picker show-toolbar :columns="majorList" value-key="displayName" @confirm="selMajorPicker"
						@cancel="showMajorPicker = false" />
				</van-popup>
				<!-- <van-field readonly clickable
					:value="category"
					name="category" 
					label="范畴" 
					placeholder="请选择范畴"
					:rules="[{ required: true, message: '' }]"
					@click="showCategoryPicker = true" />
				<van-popup v-model="showCategoryPicker" position="bottom">
					<van-picker show-toolbar :columns="categoryList" value-key="name" @confirm="selCategoryPicker" @cancel="showCategoryPicker = false" />
				</van-popup> -->
				<van-field readonly clickable :value="inspectionTime" name="inspectionTime" label="提出时间"
					placeholder="请选择提出时间" :rules="[{ required: true, message: '' }]"
					@click="showInspectionTimeCalendar = true" />
				<van-calendar v-model="showInspectionTimeCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa"
					@confirm="selInspectionTimeCalendar" />
				<!-- <van-field
					v-model="inspectionPlace"
					name="inspectionPlace"
					label="巡检地点"
					placeholder="请输入巡检地点"
				/> -->
				<van-field v-model="inspectionMan" name="inspectionMan" label="提出人" placeholder="请输入提出人"
					:rules="[{ required: true, message: '' }]" />
				<van-field class="textareaField" v-model="inspectionContent" type="textarea" name="inspectionContent"
					label="巡检内容" placeholder="请输入巡检内容" :rules="[{ required: true, message: '' }]" />
				<van-field class="textareaField" v-model="sutContent" type="textarea" name="sutContent" label="问题描述及整改意见"
					placeholder="请输入问题/整改意见" />
				<van-field readonly clickable :value="closeTime" name="closeTime" label="封闭时间" placeholder="请选择封闭时间"
					@click="showCloseTimeCalendar = true" />
				<van-calendar v-model="showCloseTimeCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa"
					@confirm="selCloseTimeCalendar" />
				<van-field v-model="closeMan" name="closeMan" label="封闭人" placeholder="请输入封闭人" />
				<van-field class="textareaField" type="textarea" v-model="remark" name="remark" label="备注"
					placeholder="请输入备注" />
			</van-cell-group>
			<!-- <van-cell-group style="margin-top: 13px;">
				<van-field name="isQuestion" label="发现问题">
				  <template #input>
				    <van-switch v-model="isQuestion" size="20" @change="handleChange"/>
				  </template>
				</van-field>
				<div v-if="isQuestion">
					<van-field readonly clickable
						:value="important"
						name="important" 
						label="重要程度" 
						placeholder="请选择重要程度"
						:rules="[{ required: true, message: '' }]"
						@click="showImportantPicker = true" />
					<van-popup v-model="showImportantPicker" position="bottom">
						<van-picker show-toolbar :columns="importantList" value-key="displayName" @confirm="selImportantPicker" @cancel="showImportantPicker = false" />
					</van-popup>
					<van-field
						class="textareaField"
						v-model="sutContent"
						type="textarea"
						name="sutContent"
						label="问题/整改意见"
						placeholder="请输入问题/整改意见"
						:rules="[{ required: true, message: '' }]"
					/>
				</div>
			</van-cell-group> -->
			<!-- <van-cell-group style="margin-top: 13px;">
				<van-field
					class="uploaderField"
					name="fileList" label="照片">
					<template #input>
						<van-uploader v-model="fileList" :after-read="uploadFile" 
						:before-delete="beforeDelete"
						accept="image/*"
						/>
					</template>
				</van-field>
			</van-cell-group> -->
			<van-cell-group style="margin-top: 13px;">
				<van-field class="uploaderField" name="scenePhotoList" label="整改前照片">
					<template #input>
						<van-uploader v-model="scenePhotoList" :after-read="uploadBeforePhoto"
							:before-delete="beforePhotoDelete" accept="image/*" />
					</template>
				</van-field>
			</van-cell-group>
			<van-cell-group style="margin-top: 13px;">
				<van-field class="uploaderField" name="closePhotoList" label="整改后照片">
					<template #input>
						<van-uploader v-model="closePhotoList" :after-read="uploadClosePhoto"
							:before-delete="closePhotoDelete" accept="image/*" />
					</template>
				</van-field>
			</van-cell-group>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">保存</van-button>
			</div>
		</van-form>

	</div>
</template>
<script>
import { info, update } from '../../api/safePatrol'
import { upload, getMajorList, getSubjectDropDown, getProblemImportant } from '../../api/commonApi'
import { Notify } from 'vant';
import ImageCompressor from '@/utils/ImageCompressor'
import common from '../../utils/common';

export default {
	name: 'safePatrolAdd',
	data() {
		return {
			subjectMatter: "",
			subjectMatterId: "",
			showSubjectMatterPicker: false,
			// 模拟数据
			subjectMatterList: [
			],
			major: "",
			majorId: "",
			showMajorPicker: false,
			// 模拟数据
			majorList: [
			],
			category: "",
			categoryId: "",
			showCategoryPicker: false,
			content: "",
			categoryList: [
				// 待拆分为质量和安全两个画面。质量：1 ； 安全：2； 进度：3
				{ id: 1, name: "质量" }
			],
			inspectionTime: "",
			inspectionPlace: "",
			showDateCalendar: false,
			showCloseTimeCalendar: false,
			showInspectionTimeCalendar: false,
			inspectionContent: "",
			// 问题/整改意见
			sutContent: "",
			isQuestion: false,
			tcDate: "",
			showTcDateCalendar: false,
			important: "",
			importantId: "",
			showImportantPicker: false,
			// 模拟数据
			importantList: [
			],
			// 巡检人
			inspectionMan: "",
			fileList: [],
			param: {},
			minDate: new Date(new Date().getFullYear() - 2, 0, 1, 0, 0, 0),
			maxDate: new Date(new Date().getFullYear() + 2, 11, 31, 23, 59, 59),
			addPhotoList: [],
			addScenePhotoList: [],
			scenePhotoList: [],
			addCloseFileList: [],
			closeFileList: [],
			addClosePhotoList: [],
			closePhotoList: [],
			closeTime: "",
			closeMan: "",
			remark: "",
			businessType: "10", // 业务类型: 01:报验记录照片 10:问题照片 11:问题及意见文件 20:收文、发文、周报、月报等文件信息 93:协调记录照片 94:质量进度照片 95:周月报照片临时文件 96:完工资料 97:合同扫描件 98:加班审核 99:请假审核"
			fileKey: "0", // 业务类型=(01、10、11、96、97、98、99)时，默认值0，业务类型=20时，需要传入文件类型下拉选择列表对应的VALUE")
		}
	},
	mounted() {
		this.project = common.getProject();
		if (this.project == null || this.project == undefined || !this.project.workNo) {
			Notify({ type: 'danger', message: '获取工作控制号失败' });
		}

		this.doGetProblemImportant()
		this.doGetSubjectDropDown()
		this.doGetMajorList()
		this.id = this.$route.query.id;
		this.getInfo(this.id)
	},
	methods: {
		formatDate(date) {
			if(date == null || date == '') {
				return ''
			}
			return date.substr(0, 10)
		},
		getInfo(id) {
			info(id).then(response => {
				if (response.data.resultCode != 200) {
					Notify({ type: 'danger', message: response.data.resultMessage });
					return
				}
				const data = response.data.body
				this.param = data
				// 回显
				this.subjectMatterId = data.subjectNo;
				if (this.subjectMatterList.length > 0) {
					this.subjectMatterList.forEach(item => {
						if (item.displayValue == this.subjectMatterId) {
							this.subjectMatter = item.displayName
						}
					})
				}
				this.major = data.majorName;
				this.majorId = data.major;
				// this.category = data.categoryName
				this.inspectionPlace = data.inspectionPlace
				this.inspectionTime = this.formatDate(data.inspectionTime)
				this.inspectionMan = data.inspectionMan
				this.inspectionContent = data.inspectionContent
				this.closeTime = this.formatDate(data.closeTime)
				this.closeMan = data.closeMan
				this.remark = data.remark
				// this.isQuestion = data.closeState == '2' ? false : true;
				// this.importantId = data.problem.iptFlg
				// if(this.importantId) {
				// 	this.importantList.forEach(item => {
				// 		if(this.importantId == item.displayValue) {
				// 			this.important = item.displayName
				// 		}
				// 	})
				// }
				// 问题/整改意见
				this.sutContent = data.sutContent
				// 整改前图片
				if (data.scenePhotoList) {
					data.scenePhotoList.forEach(item => {
						this.scenePhotoList.push(
							{ url: item.fileUri }
						)
						this.addScenePhotoList.push(item)
					})
				}
				// 整改后图片
				if (data.closePhotoList) {
					data.closePhotoList.forEach(item => {
						this.closePhotoList.push(
							{ url: item.fileUri }
						)
						this.addClosePhotoList.push(item)
					})
				}
				// 封闭文件
				if (data.closeFileList) {
					data.closeFileList.forEach(item => {
						this.closeFileList.push(
							{ url: item.fileUri }
						)
						this.addCloseFileList.push(item)
					})
				}
			})
		},
		// 标的物
		doGetSubjectDropDown() {
			getSubjectDropDown(this.project.workNo).then(response => {
				this.subjectMatterList = response.data.body
				// 如果getInfo()方法先执行完了，在这里给subjectMatter赋值。
				if (!this.subjectMatter) {
					this.subjectMatterList.forEach(item => {
						if (item.displayValue == this.subjectMatterId) {
							this.subjectMatter = item.displayName
						}
					})
				}
			})
		},
		// 根据标的物查询专业
		doGetMajorList() {
			getMajorList(this.project.workNo).then(response => {
				this.majorList = response.data.body
			})
		},
		// 重要程度
		doGetProblemImportant() {
			getProblemImportant().then(response => {
				this.importantList = response.data.body
				// 如果getInfo()方法先执行完了，在这里给important赋值。
				if (!this.important) {
					this.importantList.forEach(item => {
						if (this.importantId == item.displayValue) {
							this.important = item.displayName
						}
					})
				}
			})
		},
		goBack() {
			this.$router.push({
				name: 'safePatrolList'
			});
		},
		selSubjectMatter(data) {
			this.subjectMatter = data.displayName;
			this.showSubjectMatterPicker = false;
			if (this.subjectMatterId != data.displayValue) {
				this.subjectMatterId = data.displayValue
				// clear major value
				this.major = ""
				this.majorId = ""
			}
		},
		selMajorPicker(data) {
			this.major = data.displayName;
			this.majorId = data.displayValue;
			this.showMajorPicker = false;
		},
		selCategoryPicker(data) {
			this.category = data.name;
			this.categoryId = data.id;
			this.showCategoryPicker = false;
		},
		selInspectionTimeCalendar(date) {
			this.inspectionTime = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showInspectionTimeCalendar = false;
		},
		selCloseTimeCalendar(date) {
			this.closeTime = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showCloseTimeCalendar = false;
		},
		selImportantPicker(data) {
			this.important = data.displayName;
			this.importantId = data.displayValue;
			this.showImportantPicker = false;
		},
		handleChange(value) {
			if (!value) {
				this.important = ''
				this.importantId = ''
				this.sutContent = ''
			}
			console.log("this.sutContent : " + this.sutContent)
		},
		async uploadFile(file) {
			// 此时可以自行将文件上传至服务器
			const files = file.file;
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();
			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const dataBody = response.data.body
					this.addCloseFileList.push(
						{
							recFileType: '2',
							fileName: this.extractFileName(dataBody.fileName),
							filePath: dataBody.fileSavePath,
							photoPathUri: dataBody.fileUri
						}
					)
				}
			})
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		async uploadClosePhoto(file) {
			// 此时可以自行将文件上传至服务器
			const files = file.file;
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();

			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const dataBody = response.data.body
					this.addClosePhotoList.push(
						{
							recFileType: '1',
							fileName: dataBody.fileName,
							filePath: dataBody.fileSavePath,
							photoPathUri: dataBody.fileUri
						}
					)
				}
			})
		},
		async uploadBeforePhoto(file) {
			console.log(file)
			// 此时可以自行将文件上传至服务器
			const files = file.file;
			console.log(files)
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();

			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const dataBody = response.data.body
					this.addScenePhotoList.push(
						{
							recFileType: '0',
							fileName: dataBody.fileName,
							filePath: dataBody.fileSavePath,
							photoPathUri: dataBody.fileUri
						}
					)
					console.log(this.addScenePhotoList)
				}
			})
		},
		beforeDelete(file, detail) {
			this.fileList.splice(detail.index, 1)
			// 删除照片
			this.addPhotoList.splice(detail.index, 1)
		},
		beforePhotoDelete(file, detail) {
			this.scenePhotoList.splice(detail.index, 1)
			// 删除照片
			this.addScenePhotoList.splice(detail.index, 1)
		},
		closePhotoDelete(file, detail) {
			this.closePhotoList.splice(detail.index, 1)
			// 删除照片
			this.addClosePhotoList.splice(detail.index, 1)
		},
		closeFileDelete(file, detail) {
			this.closeFileList.splice(detail.index, 1)
			// 删除文件
			this.addCloseFileList.splice(detail.index, 1)
		},
		onSubmit(data) {
			if (!common.hasPermision("patrol:edit:2")) {
				Notify({ type: 'danger', message: "无操作权限" });
				return;
			}
			this.param.t = new Date().getTime(),
				this.param.inspectionTime = this.inspectionTime,
				this.param.major = this.majorId,
				this.param.inspectionPlace = this.inspectionPlace,
				this.param.inspectionMan = this.inspectionMan,
				this.param.inspectionContent = this.inspectionContent,
				this.param.closeTime = this.closeTime,
				this.param.closeMan = this.closeMan,
				this.param.remark = this.remark,
				// 图片list
				this.param.scenePhotoList = this.addScenePhotoList,
				this.param.closeFileList = this.addCloseFileList,
				this.param.closePhotoList = this.addClosePhotoList,
				this.param.problem.sutContent = this.sutContent,
				// this.param.problem.iptFlg = this.importantId,
				// this.param.probContext = this.probContext,
				this.param.sutContent = this.sutContent,
				this.param.iptFlg = this.importantId,

				update(this.param).then(response => {
					if (response.data.resultCode === 200) {
						Notify({ type: 'success', message: '操作成功' });
						this.goBack()
					} else {
						Notify({ type: 'danger', message: response.data.resultMessage });
					}
				})
		},
	}
}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>